import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Testimonials.css";

gsap.registerPlugin(ScrollTrigger);

const testimonials = [
  {
    text: "Acence completely transformed our brand identity. From logo design to our digital presence, everything was crafted with precision and creativity. The team truly understands how to make a brand stand out.",
    author: "Rahul Mehta",
    role: "Startup Founder",
  },
  {
    text: "Working with Acence was a seamless experience. Their website design and social media strategy helped us attract more customers and significantly improve our online engagement.",
    author: "Ananya Sharma",
    role: "Business Owner",
  },
  {
    text: "Acence exceeded our expectations in every way. Their attention to detail, creative approach, and timely delivery made them the perfect partner for our branding and marketing needs.",
    author: "Vikram Patel",
    role: "Marketing Head",
  },
];

const Testimonials = () => {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".testimonials-heading", {
        opacity: 0,
        y: 40,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      });

      gsap.from(cardsRef.current, {
        opacity: 0,
        y: 50,
        stagger: 0.2,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
        },
      });

      // Looping floating animation
      cardsRef.current.forEach((card, i) => {
        gsap.to(card, {
          y: i % 2 === 0 ? -10 : 10,
          duration: 3 + i,
          ease: "sine.inOut",
          repeat: -1,
          yoyo: true,
        });
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="testimonials-section" ref={sectionRef}>
      <h2 className="testimonials-heading">
        What Our Customers Are Saying
      </h2>

      <div className="testimonials-grid">
        {testimonials.map((item, index) => (
          <div
            key={index}
            className="testimonial-card"
            ref={(el) => (cardsRef.current[index] = el)}
          >
            <p className="testimonial-text">“{item.text}”</p>
            <div className="testimonial-author">
              <strong>{item.author}</strong>
              <span>{item.role}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
